import { render, staticRenderFns } from "./TypographyItem.vue?vue&type=template&id=52d4e89b&scoped=true&"
import script from "./TypographyItem.vue?vue&type=script&lang=js&"
export * from "./TypographyItem.vue?vue&type=script&lang=js&"
import style0 from "./TypographyItem.vue?vue&type=style&index=0&id=52d4e89b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d4e89b",
  null
  
)

export default component.exports